import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCountdown from "./components/HeroCountdown";
import TeamHighlights from "./components/TeamHighlights";
import TicketOptions from "./components/TicketOptions";
import Full90Deal from "./components/Full90Deal";
import GameSchedule from "./components/GameSchedule";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <main>
        <HeroCountdown />
        <GameSchedule />
        <TicketOptions />
        <Full90Deal />
        <TeamHighlights />
      </main>
      <Footer />
    </div>
  );
}
